import React, { useState } from "react";
import gh from '../Images/ccc.jpg';
import UserPageHeader from '../components/UserPageHeader';

const AboutUs = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [statsVisible, setStatsVisible] = useState(false);

  // Stats counter animation
  const [clientsCount, setClientsCount] = useState(0);
  const [vehiclesCount, setVehiclesCount] = useState(0);
  const [citiesCount, setCitiesCount] = useState(0);
  const [tripsCount, setTripsCount] = useState(0);

  const startCountAnimation = () => {
    if (!statsVisible) {
      setStatsVisible(true);
      animateValue(setClientsCount, 0, 5000, 2000);
      animateValue(setVehiclesCount, 0, 250, 1500);
      animateValue(setCitiesCount, 0, 40, 1800);
      animateValue(setTripsCount, 0, 12000, 2500);
    }
  };

  const animateValue = (setter, start, end, duration) => {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      const value = Math.floor(progress * (end - start) + start);
      setter(value);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  };

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const tabs = [
    {
      title: "Our Story",
      content: "Founded in 2010, CarRental began with a simple mission: to make car rental hassle-free and enjoyable. Today, we serve thousands of customers across the country with our diverse fleet of well-maintained vehicles."
    },
    {
      title: "Our Mission",
      content: "We strive to provide exceptional rental experiences with transparent pricing, 24/7 customer support, and vehicles that meet the highest standards of safety and comfort."
    },
    {
      title: "Our Values",
      content: "Integrity, customer satisfaction, and innovation are at the core of everything we do. We're committed to reducing our environmental impact through our growing fleet of hybrid and electric vehicles."
    }
  ];

  const teamMembers = [
    { name: "John Smith", role: "CEO & Founder", fact: "Has been in the car industry for 15+ years" },
    { name: "Sarah Johnson", role: "Operations Director", fact: "Loves organizing efficient processes" },
    { name: "Michael Chen", role: "Fleet Manager", fact: "Knows every car model inside out" },
    { name: "Emma Wilson", role: "Customer Experience", fact: "Always goes the extra mile for clients" }
  ];

  const accordionItems = [
    { question: "What types of vehicles do you offer?", answer: "We offer a wide range of vehicles from economy cars to luxury SUVs and vans. We also have a growing selection of hybrid and electric vehicles." },
    { question: "How do I make a reservation?", answer: "You can book online through our website, call our reservation hotline, or visit one of our rental locations." },
    { question: "What are your rental requirements?", answer: "Renters must be at least 21 years old with a valid driver's license and credit card. Additional documentation may be required for certain vehicle categories." },
    { question: "Do you offer long-term rentals?", answer: "Yes, we offer special rates for rentals longer than 28 days. Contact our team for customized long-term rental options." }
  ];

  return (
    <div className="relative min-h-screen w-full overflow-x-hidden">
      <UserPageHeader/>
      
      {/* Background Image */}
      <img
        src={gh} 
        alt="Luxury car rental"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Overlay Section */}
      <div className="absolute inset-0 bg-black/40"></div>
      
      <div className="relative z-10 pt-24 pb-16 px-6">
        <div className="max-w-6xl mx-auto">
          {/* Main Hero Section */}
          <div className="bg-blue-400 bg-opacity-50 backdrop-blur-sm rounded-2xl p-8 md:p-12 mb-12 text-white">
            <p className="text-lg font-semibold mb-3 text-white">Know About Us</p>
            <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
              We Make Your Drive <br /> Memorable.
            </h1>
            <p className="text-lg leading-relaxed mb-8 max-w-2xl">
              It's very painful to get rid of obesity. That Just the Littlest Where,
              Refused to See, Will the Seasons of Life Open Up, for the Most Said? 
              He Repels Him Wants to Be Repelled by the Pleasure of Choosing Things.
            </p>
            
            <button 
              onClick={startCountAnimation}
              className="bg-white text-blue-700 px-8 py-4 rounded-xl font-semibold hover:bg-blue-100 transition duration-300 flex items-center group"
            >
              Discover Our Journey
              <svg 
                className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24" 
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
              </svg>
            </button>
          </div>

          {/* Stats Section - Appears after clicking button */}
          {statsVisible && (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16 animate-fade-in">
              <div className="bg-white bg-opacity-90 rounded-xl p-6 text-center shadow-lg">
                <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">{clientsCount}+</div>
                <div className="text-gray-700">Happy Clients</div>
              </div>
              <div className="bg-white bg-opacity-90 rounded-xl p-6 text-center shadow-lg">
                <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">{vehiclesCount}+</div>
                <div className="text-gray-700">Vehicles</div>
              </div>
              <div className="bg-white bg-opacity-90 rounded-xl p-6 text-center shadow-lg">
                <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">{citiesCount}+</div>
                <div className="text-gray-700">Cities</div>
              </div>
              <div className="bg-white bg-opacity-90 rounded-xl p-6 text-center shadow-lg">
                <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">{tripsCount}+</div>
                <div className="text-gray-700">Trips Completed</div>
              </div>
            </div>
          )}

          {/* Tabbed Content Section */}
          <div className="bg-white bg-opacity-90 backdrop-blur-sm rounded-2xl p-6 mb-12 shadow-lg">
            <div className="flex flex-wrap border-b mb-6">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  className={`py-3 px-6 font-medium rounded-t-lg transition-colors ${activeTab === index ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-500 hover:text-gray-700'}`}
                  onClick={() => setActiveTab(index)}
                >
                  {tab.title}
                </button>
              ))}
            </div>
            <div className="p-4 text-gray-700 min-h-[120px]">
              <p className="text-lg">{tabs[activeTab].content}</p>
            </div>
          </div>

          {/* Team Section */}
          <div className="bg-white bg-opacity-90 backdrop-blur-sm rounded-2xl p-8 mb-12 shadow-lg">
            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Meet Our Team</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {teamMembers.map((member, index) => (
                <div key={index} className="bg-gray-50 rounded-xl p-6 text-center group hover:bg-blue-50 transition-colors">
                  <div className="w-20 h-20 mx-auto mb-4 bg-blue-200 rounded-full flex items-center justify-center text-blue-600 text-xl font-bold">
                    {member.name.split(' ').map(n => n[0]).join('')}
                  </div>
                  <h3 className="font-bold text-gray-800">{member.name}</h3>
                  <p className="text-blue-600 mb-2">{member.role}</p>
                  <p className="text-sm text-gray-600 group-hover:opacity-100 opacity-0 transition-opacity">
                    {member.fact}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* FAQ Accordion Section */}
          <div className="bg-white bg-opacity-90 backdrop-blur-sm rounded-2xl p-8 shadow-lg">
            <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Frequently Asked Questions</h2>
            <div className="space-y-4">
              {accordionItems.map((item, index) => (
                <div key={index} className="border rounded-xl overflow-hidden">
                  <button
                    className="flex justify-between items-center w-full p-5 text-left font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                    onClick={() => toggleAccordion(index)}
                  >
                    <span>{item.question}</span>
                    <svg 
                      className={`w-5 h-5 transition-transform ${activeAccordion === index ? 'rotate-180' : ''}`} 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24" 
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                    </svg>
                  </button>
                  <div className={`overflow-hidden transition-all duration-300 ${activeAccordion === index ? 'max-h-40' : 'max-h-0'}`}>
                    <div className="p-5 text-gray-600 bg-gray-50">
                      {item.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fadeIn 0.8s ease-out forwards;
        }
      `}</style>
    </div>
  );
};

export default AboutUs;